const BARE_VENDOR_DIGITS = /^\d{5,}$/;
const PREFIXED_VENDOR_DIGITS = /^[A-Za-z]{1,8}\d{5,}$/;

/**
 * A company's `originId` as a displayable COMPANY CODE, or null when it is not
 * one.
 *
 * Division-prefixed vendor origins (`RA50109`, `QE00043`, `RA:RA50109`) are
 * vendor numbers, not company codes — hidden so the vendor# field is what Rexel
 * works by. Shared between the pricelist pages (the Company Code column) and
 * the price-file log export (the "3 LETTER CODE / PG" default), so the two can
 * never disagree about what a code is.
 */
export function displayCompanyCode(
  originId: string | null | undefined,
): string | null {
  if (originId == null) return null;
  const trimmed = originId.trim();
  if (trimmed === "") return null;
  const separator = trimmed.lastIndexOf(":");
  const segment = separator === -1 ? trimmed : trimmed.slice(separator + 1);
  if (
    BARE_VENDOR_DIGITS.test(segment) ||
    PREFIXED_VENDOR_DIGITS.test(segment)
  ) {
    return null;
  }
  return trimmed;
}
